/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/290-first': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M2 14V2h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5V14z"/>'
  }
})
